import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { List } from 'immutable';
import { BLOCK_DELIMITER } from '../utils/constants';
import insertOperation from './insertOperation';
import retainOperation from './retainOperation';
import deleteOperation from './deleteOperation';
import whileMaintainingSelection from './utils/whileMaintainingSelection';
var TEMPORARY_BLOCK = 'TEMPORARY_BLOCK';

function getOperationType(op) {
  if (op.insert !== undefined) {
    return insertOperation;
  } else if (op.retain !== undefined) {
    return retainOperation;
  } else if (op["delete"] !== undefined) {
    return deleteOperation;
  } else {
    console.debug('Unknown OP %O', op);
    throw new Error('Unknown OP');
  }
}

var operationReducer = function operationReducer(editor, op) {
  getOperationType(op)(editor, op);
  return editor;
};

var intersperse = function intersperse(array) {
  if (array.length < 2) {
    return array;
  }

  var result = [];

  for (var i = 0; i < array.length; i++) {
    if (i !== 0) {
      result.push(BLOCK_DELIMITER);
    }

    result.push(array[i]);
  }

  return result;
};

var splitOperationByDelimiter = function splitOperationByDelimiter(_ref) {
  var text = _ref.insert,
      attributes = _objectWithoutProperties(_ref, ["insert"]);

  return intersperse(text.split(BLOCK_DELIMITER)).filter(function (insert) {
    return insert.length > 0;
  }).map(function (insert) {
    return _objectSpread({
      insert: insert
    }, attributes);
  });
};

var splitOperationsByDelimiter = function splitOperationsByDelimiter(ops, op) {
  return op.insert && op.insert !== BLOCK_DELIMITER ? ops.concat(splitOperationByDelimiter(op)) : ops.concat(op);
};

function removeTemporaryBlocks(editor) {
  editor.value.document.getBlocksByType(TEMPORARY_BLOCK).forEach(function (block) {
    editor.removeNodeByKey(block.key);
  });
}

export default (function (delta, editor) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$save = _ref2.save,
      save = _ref2$save === void 0 ? false : _ref2$save;

  if (save) {
    delta.reduce(splitOperationsByDelimiter, []).reduce(operationReducer, editor);
  } else {
    editor.withoutSaving(function () {
      whileMaintainingSelection(editor, function () {
        editor.withoutNormalizing(function () {
          delta.reduce(splitOperationsByDelimiter, []).reduce(operationReducer, editor);
          removeTemporaryBlocks(editor);
        });
      });
      editor.controller.operations = new List();
    });
  }

  return editor;
});